import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { CardComponent } from './card/card.component';
import { CardActionProgressComponent } from './card-action-progress/card-action-progress.component';
import { CardBadgeComponent } from './card-badge/card-badge.component';
import { CardBadgeWrapperComponent } from './card-badge-wrapper/card-badge-wrapper.component';
import { CardCheckmarkComponent } from './card-checkmark/card-checkmark.component';
import { CardContentComponent } from './card-content/card-content.component';
import { CardDividerComponent } from './card-divider/card-divider.component';
import { CardHeaderComponent } from './card-header/card-header.component';
import { CardIconComponent } from './card-icon/card-icon.component';
import { CardIconIndicatorComponent } from './card-icon-indicator/card-icon-indicator.component';
import { CardListComponent } from './card-list/card-list.component';
import { CardListItemComponent } from './card-list-item/card-list-item.component';
import { CardNoteComponent } from './card-note/card-note.component';
import { CardProgressIndicatorComponent } from './card-progress-indicator/card-progress-indicator.component';
import { CardScoreIndicatorComponent } from './card-score-indicator/card-score-indicator.component';
import { CardSegmentIndicatorComponent } from './card-segment-indicator/card-segment-indicator.component';
import { CardSubTitleComponent } from './card-sub-title/card-sub-title.component';
import { CardTitleComponent } from './card-title/card-title.component';

@NgModule({
  imports: [CommonModule, IonicModule, RouterModule, TranslateModule],
  declarations: [
    CardActionProgressComponent,
    CardBadgeComponent,
    CardCheckmarkComponent,
    CardComponent,
    CardContentComponent,
    CardDividerComponent,
    CardHeaderComponent,
    CardIconComponent,
    CardIconIndicatorComponent,
    CardListComponent,
    CardListItemComponent,
    CardNoteComponent,
    CardProgressIndicatorComponent,
    CardScoreIndicatorComponent,
    CardSegmentIndicatorComponent,
    CardSubTitleComponent,
    CardTitleComponent,
    CardBadgeWrapperComponent,
  ],
  exports: [
    CardActionProgressComponent,
    CardBadgeComponent,
    CardCheckmarkComponent,
    CardComponent,
    CardContentComponent,
    CardDividerComponent,
    CardHeaderComponent,
    CardIconComponent,
    CardIconIndicatorComponent,
    CardListComponent,
    CardListItemComponent,
    CardNoteComponent,
    CardProgressIndicatorComponent,
    CardScoreIndicatorComponent,
    CardSegmentIndicatorComponent,
    CardSubTitleComponent,
    CardTitleComponent,
    CardBadgeWrapperComponent,
  ],
})
export class CardUiModule {}
